import { Asterisk } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";

const MandatoryIndication: React.FC = () => (
  <IconContainer>
    <Asterisk />
  </IconContainer>
);

export default MandatoryIndication;
